enum Modals {
  MoodSupport = "mood-support-modal",
  WhatsAppTerms = "whatsApp-terms-permission",
  whatsAppComingSoon = "whatsapp-coming-soon",
}
export default Modals;
